import { MilestoneTaskEstimateChangedAlert } from "./MilestoneTaskEstimateChangedAlert";
import { MilestoneTaskEstimateChangedAlertResponse } from "./MilestoneTaskEstimateChangedAlertResponse";
import { TaskReportResponseMapper } from "../taskReports/TaskReportResponseMapper";

export class MilestoneTaskEstimateChangedAlertResponseMapper {
  private taskReportResponseMapper = new TaskReportResponseMapper();

  mapMilestoneTaskEstimateChangedAlertResponseToMilestoneTaskEstimateChangedAlert(
    response: MilestoneTaskEstimateChangedAlertResponse
  ): MilestoneTaskEstimateChangedAlert {
    return {
      id: response.id,
      milestoneTaskId: response.milestoneTaskId,
      milestoneTask: this.taskReportResponseMapper.mapMilestoneTaskResponseToMilestoneTask(
        response.milestoneTask
      ),
      from: response.from,
      to: response.to,
      dateCreated: response.dateCreated,
      dateModified: response.dateModified,
    };
  }
} 